<template>
  <v-container fluid style="position: relative; padding: 0" class="secondary mainHomeContainer" app v-resize="onResize">
    <v-flex style="position: absolute; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;z-index: 9;" v-if="loading">
      <v-progress-circular :size="70" :width="7" color="accent" indeterminate></v-progress-circular>
    </v-flex>
    <v-flex style="padding: 40px 5%; font-size: 24px; font-weight: 700;">
      <div class="primary--text">All subscribed projects</div>
    </v-flex>
    <v-flex class="subscriptionProjectsContainer" id="subscriptionProjectsContainer" :class="loading ? 'blurClass' : ''">
      <v-flex v-if="subscribedProjects.length > 0" v-for="(item, index) in subscribedProjects" :key="index" style="transition: 200ms all ease" :style="item.type && item.type === 'panel' ? 'width: 100%' : 'flex:none'" @click="toggleSubscriptionPanel(item, index)">
        <div class="projectPanel primary mb-2" v-if="item.type && item.type === 'panel'" :style="'width: ' + item.width + 'px'">
          <ProjectPanel v-on:manage-project="manageProject(item)" v-on:manage-users="manageUsers(item)" v-on:subscribe="subscribeToProject" v-bind:options="{project: item}"></ProjectPanel>
        </div>
        <div v-else class="projectCard" :style="{ 'background-image': 'url(' + item.config.unsplashImageUrl + ')' }">
          <div class="projectOverlay"></div>
          <div class="projectInfo">
            <div class="projectName secondary--text">{{item.name}}</div>
            <div class="projectOrganization secondary--text">{{getOrganizationName(item)}}</div>
          </div>
          <div class="projectArrow secondary--text" v-if="selectedSubscriptionProject && selectedSubscriptionProject.id === item.id"><div class="projectArrowDown"></div></div>
        </div>
      </v-flex>
      <v-flex v-if="subscribedProjects.length === 0 && loading === false" style="font-size: 24px;" class="primary--text">You haven’t yet subscribed to any project, <span style="color: #2165FF; cursor: pointer" @click="$router.push('/market')">browse projects</span> to find one.</v-flex>
    </v-flex>
    <v-flex style="padding: 40px 5%; font-size: 24px; font-weight: 700;">
      <div class="primary--text">Projects created by your organization</div>
    </v-flex>
    <v-flex class="diyProjectsContainer" id="diyProjectsContainer" :class="loading ? 'blurClass' : ''" style="margin-bottom: 60px;">
      <v-flex v-if="diyProjects.length > 0" style="transition: 200ms all ease" v-for="(item, index) in diyProjects" :key="index" :style="item.type && item.type === 'panel' ? 'width: 100%' : 'flex:none'" @click="toggleDiyPanel(item, index)">
        <div class="projectPanel primary mb-2" v-if="item.type && item.type === 'panel'" :style="'width: ' + item.width + 'px'">
          <ProjectPanel v-on:manage-project="manageProject(item)" v-on:manage-users="manageUsers(item)" v-on:subscribe="subscribeToProject" v-bind:options="{project: item}"></ProjectPanel>
        </div>
        <div v-else class="projectCard" :style="{ 'background-image': 'url(' + item.config.unsplashImageUrl + ')' }">
          <div class="projectOverlay"></div>
          <div class="projectInfo">
            <div class="projectName secondary--text">{{item.name}}</div>
            <div class="projectOrganization secondary--text">{{getOrganizationName(item)}}</div>
          </div>
          <div class="projectArrow secondary--text" v-if="selectedDiyProject && selectedDiyProject.id === item.id"><div class="projectArrowDown"></div></div>
        </div>
      </v-flex>
      <v-flex v-if="diyProjects.length === 0 && loading === false" @click="$router.push('/diy')" style="cursor: pointer">
        <div style="width: 280px">
          <img src="@/assets/create.png" style="width: 280px" />
          <div style="text-align: center; font-size: 18px;" class="primary--text">Create your first project</div>
        </div>
      </v-flex>
    </v-flex>
    <v-flex style="padding: 40px 5%; font-size: 24px; font-weight: 700;" v-if="ownProjects.length > 0">
      <div class="primary--text">Your pending projects</div>
    </v-flex>
    <v-flex class="ownProjectsContainer" id="ownProjectsContainer" :class="loading ? 'blurClass' : ''" style="margin-bottom: 60px;" v-if="ownProjects.length > 0">
      <v-flex style="transition: 200ms all ease" v-for="(item, index) in ownProjects" :key="index" :style="item.type && item.type === 'panel' ? 'width: 100%' : 'flex:none'" @click="toggleOwnPanel(item, index)">
        <div class="projectPanel primary mb-2" v-if="item.type && item.type === 'panel'" :style="'width: ' + item.width + 'px'">
          <ProjectPanel v-on:manage-project="manageProject(item)" v-on:manage-users="manageUsers(item)" v-on:subscribe="subscribeToProject" v-bind:options="{project: item}"></ProjectPanel>
        </div>
        <div v-else class="projectCard" :style="{ 'background-image': 'url(' + item.config.unsplashImageUrl + ')' }">
          <div class="projectOverlay"></div>
          <div class="projectInfo">
            <div class="projectName secondary--text">{{item.name}}</div>
            <div class="projectOrganization secondary--text">{{getOrganizationName(item)}}</div>
          </div>
          <div class="projectArrow secondary--text" v-if="selectedOwnProject && selectedOwnProject.id === item.id"><div class="projectArrowDown"></div></div>
        </div>
      </v-flex>
    </v-flex>
    <v-dialog
      v-if="selectedProject"
      v-model="subscribeDialog"
      persistent
      scrollable
      fullscreen
      transition="dialog-transition"
    >
      <Subscribe v-on:close-subscribe-dialog="subscribeDialog = false; selectedProject = null" v-bind:options="{project: selectedProject, planId: selectedPlanId, dialogType: dialogType}"></Subscribe>
    </v-dialog>
    <v-dialog
      v-if="selectedProject"
      v-model="manageDialog"
      persistent
      fullscreen
      transition="dialog-transition"
    >
      <ManageProject v-on:close-manage-dialog="manageDialog = false; selectedProject = null" v-bind:options="{project: selectedProject}"></ManageProject>
    </v-dialog>
  </v-container>
</template>

<style>
  .blurClass{
    -webkit-filter: blur(5px);
    filter: blur(5px);
  }
  .projectPanel{
    height: 500px;
    position: relative;
    transition: 400ms all ease-in-out;
  }
  .subscriptionProjectsContainer, .diyProjectsContainer, .ownProjectsContainer{
    padding: 0 5%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  .mainHomeContainer .projectArrow{
    position: absolute;
    top: 100%;
    margin-top: 5px;
    left: 0;
    right: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    z-index: 9
  }
  .mainHomeContainer .projectArrowDown{
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 15px solid white;
  }
  .projectCard{
    position: relative;
    width: 260px;
    height: 160px;
    flex: none;
    margin-bottom: 5px;
    margin-right: 5px;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }
  .projectTitle{
    width: 100%;
    text-align: center;
    font-size: 36px;
    font-weight: 800;
  }
  .projectsCards{
    position: relative;
    width: 100%;
  }
  .projectContainer{
    position: relative;
    flex: none;
  }
  .projectOverlay{
    background: #000000;
    opacity: 0.5;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 4;
  }
  .projectInfo{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 25px;
    z-index: 6;
  }
  .projectName{
    font-size: 18px;
    font-weight: 700;
  }
  .projectOrganization{
    font-weight: 500;
    font-size: 12px;
  }
</style>

<script>
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'
import ProjectPanel from '../appElements/ProjectPanel.vue'
import Subscribe from '../Subscribe.vue'
import underscore from 'underscore'
import ManageProject from '../appElements/ManageProject.vue'

export default{
  data () {
    return {
      subscribedProjects: [],
      selectedSubscriptionProject: null,
      selectedProject: null,
      subscribeDialog: false,
      diyProjects: [],
      ownProjects: [],
      projects: [],
      selectedPlanId: null,
      selectedDiyProject: null,
      selectedOwnProject: null,
      panelWidth: 0,
      numberOfElements: 3,
      openIndexSubscription: null,
      subPanelIndex: null,
      openIndexDiy: null,
      openIndexOwn: null,
      diyPanelIndex: null,
      ownPanelIndex: null,
      dialogType: 'projects',
      manageDialog: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters({
      getUserOrganization: 'getUserOrganization'
    }),
    getHeaderWidth () {
      var width = this.panelWidth === 0 ? '100%' : this.panelWidth + 'px'
      return 'width: ' + width
    }
  },
  mounted () {
    this.onResize()
    if ((Array.isArray(this.getUserOrganization) && this.getUserOrganization.length > 0) || (Object.keys(this.getUserOrganization) && Object.keys(this.getUserOrganization).length !== 0)) {
      this.getData()
    }
  },
  watch: {
    getUserOrganization: function (newVal, oldVal) {
      if (!underscore.isEqual(newVal, oldVal)) {
        if ((Array.isArray(newVal) && newVal.length > 0) || (Object.keys(newVal) && Object.keys(newVal).length !== 0)) {
          this.getData()
        }
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    manageProject (project) {
      this.selectedProject = project
      this.manageDialog = true
    },
    manageUsers (project) {
      this.selectedProject = project
      this.dialogType = 'users'
      this.subscribeDialog = true
    },
    onResize () {
      if (document.getElementById('subscriptionProjectsContainer')) {
        this.numberOfElements = Math.floor((document.getElementById('subscriptionProjectsContainer').offsetWidth - (document.getElementById('subscriptionProjectsContainer').offsetWidth * 0.1)) / 265)
        this.panelWidth = (265 * this.numberOfElements) - 5
        var diyPanelIndex = this.diyProjects.findIndex(item => { return item.type && item.type === 'panel' })
        if (diyPanelIndex !== -1) {
          this.diyProjects.splice(diyPanelIndex, 1)
          this.diyPanelIndex = null
        }
        this.openIndexDiy = null
        this.selectedDiyProject = null
        var subPanelIndex = this.subscribedProjects.findIndex(item => { return item.type && item.type === 'panel' })
        if (subPanelIndex !== -1) {
          this.subscribedProjects.splice(subPanelIndex, 1)
          this.subPanelIndex = null
        }
        this.openIndexSubscription = null
        this.selectedSubscriptionProject = null
        var ownPanelIndex = this.ownProjects.findIndex(item => { return item.type && item.type === 'panel' })
        if (ownPanelIndex !== -1) {
          this.ownProjects.splice(ownPanelIndex, 1)
          this.ownPanelIndex = null
        }
        this.openIndexOwn = null
        this.selectedOwnProject = null
      }
    },
    getData () {
      this.projects = []
      this.diyProjects = []
      this.ownProjects = []
      this.loading = true
      axios.all([this.$store.dispatch('getProjectsWithAllByUserId', {id: this.currentUser.id}), this.$store.dispatch('getProjectsWithAllByCreatedByUserId', {id: this.currentUser.id})]).then(axios.spread((subscriptionResponse, ownProjectsResponse) => {
        if (subscriptionResponse.data.status === 'SUCCESS' && ownProjectsResponse.data.status === 'SUCCESS') {
          this.subscribedProjects = subscriptionResponse.data.payload
          this.projects.concat(subscriptionResponse.data.payload)
          if (this.subscribedProjects && this.subscribedProjects.length > 0) {
            this.toggleSubscriptionPanel(this.subscribedProjects[0], 0)
          }
          for (var op = 0; op < ownProjectsResponse.data.payload.length; op++) {
            if (!ownProjectsResponse.data.payload[op].status.toLowerCase().includes('active')) {
              this.ownProjects.push(ownProjectsResponse.data.payload[op])
            }
          }
          var diyProjects = this.getUserOrganization.organizationProjects.filter(item => { return item.type === 'DIY' })
          if (diyProjects.length > 0) {
            for (var d = 0; d < diyProjects.length; d++) {
              axios.all([this.$store.dispatch('getProjectWithAllById', {id: diyProjects[d].projectId})]).then(axios.spread((response) => {
                if (response.data.status === 'SUCCESS') {
                  if (response.data.payload) {
                    if (!this.diyProjects.find(item => { return Number(item.id) === Number(response.data.payload.id) })) {
                      this.diyProjects.push(response.data.payload)
                      if (d >= this.diyProjects.length) {
                        this.loading = false
                      }
                    }
                  }
                } else {
                  this.loading = false
                  this.notify({message: 'Something went wrong.', show: true})
                }
              })).catch((err) => {
                this.loading = false
                this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                console.log(err)
              })
            }
          } else {
            this.loading = false
          }
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.loading = false
        console.log(err)
      })
    },
    getOrganizationName (project) {
      var organization = project.organizations.find(item => { return item.id === project.createdByOrganizationId })
      if (organization) {
        return organization.name
      }
      return ''
    },
    toggleSubscriptionPanel (project, index) {
      if (!project || !project.type || project.type !== 'panel') {
        if (index !== this.openIndexSubscription) {
          if (this.subPanelIndex) {
            index = this.subPanelIndex < index ? index - 1 : index
            this.subscribedProjects.splice(this.subscribedProjects.findIndex(function (project) { return project.type && project.type === 'panel' }), 1)
          }
          this.openIndexSubscription = index
          this.subPanelIndex = Math.ceil((index + 1) / this.numberOfElements) * this.numberOfElements
          var projectDetails = JSON.parse(JSON.stringify(project))
          projectDetails.type = 'panel'
          projectDetails.width = (265 * this.numberOfElements) - 5
          var self = this
          setTimeout(function () {
            self.subscribedProjects.splice(self.subPanelIndex, 0, projectDetails)
            self.selectedSubscriptionProject = project
          }, 2)
        } else {
          var panelIndex = this.subscribedProjects.findIndex(item => { return item.type && item.type === 'panel' })
          if (panelIndex !== -1) {
            this.subscribedProjects.splice(panelIndex, 1)
            this.subPanelIndex = null
          }
          this.openIndexSubscription = null
          this.selectedSubscriptionProject = null
        }
      }
    },
    toggleDiyPanel (project, index) {
      if (!project.type || project.type !== 'panel') {
        if (index !== this.openIndexDiy) {
          if (this.diyPanelIndex) {
            index = this.diyPanelIndex < index ? index - 1 : index
            this.diyProjects.splice(this.diyProjects.findIndex(function (project) { return project.type && project.type === 'panel' }), 1)
          }
          this.openIndexDiy = index
          this.diyPanelIndex = Math.ceil((index + 1) / this.numberOfElements) * this.numberOfElements
          var projectDetails = JSON.parse(JSON.stringify(project))
          projectDetails.type = 'panel'
          projectDetails.width = (265 * this.numberOfElements) - 5
          var self = this
          setTimeout(function () {
            self.diyProjects.splice(self.diyPanelIndex, 0, projectDetails)
            self.selectedDiyProject = project
          }, 2)
        } else {
          var panelIndex = this.diyProjects.findIndex(item => { return item.type && item.type === 'panel' })
          if (panelIndex !== -1) {
            this.diyProjects.splice(panelIndex, 1)
            this.diyPanelIndex = null
          }
          this.openIndexDiy = null
          this.selectedDiyProject = null
        }
      }
    },
    toggleOwnPanel (project, index) {
      if (!project.type || project.type !== 'panel') {
        if (index !== this.openIndexOwn) {
          if (this.ownPanelIndex) {
            index = this.ownPanelIndex < index ? index - 1 : index
            this.ownProjects.splice(this.ownProjects.findIndex(function (project) { return project.type && project.type === 'panel' }), 1)
          }
          this.openIndexOwn = index
          this.ownPanelIndex = Math.ceil((index + 1) / this.numberOfElements) * this.numberOfElements
          var projectDetails = JSON.parse(JSON.stringify(project))
          projectDetails.type = 'panel'
          projectDetails.width = (265 * this.numberOfElements) - 5
          var self = this
          setTimeout(function () {
            self.ownProjects.splice(self.ownPanelIndex, 0, projectDetails)
            self.selectedOwnProject = project
          }, 2)
        } else {
          var panelIndex = this.ownProjects.findIndex(item => { return item.type && item.type === 'panel' })
          if (panelIndex !== -1) {
            this.ownProjects.splice(panelIndex, 1)
            this.ownPanelIndex = null
          }
          this.openIndexOwn = null
          this.selectedOwnProject = null
        }
      }
    },
    subscribeToProject (subscriptionObject) {
      this.subscribeDialog = true
      this.selectedProject = this.projects.find(item => { return item.id === subscriptionObject.projectId })
      this.selectedPlanId = subscriptionObject.planId
    }
  },
  components: {
    Subscribe,
    ProjectPanel,
    ManageProject
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/HomeLoggedIn.vue